module.exports = __webpack_public_path__ + "img/phone1.9062f559.png";